import { AES, enc, MD5 } from 'crypto-js';
import { config } from 'env_def';
import debounce from 'lodash/debounce';
import cloneDeepWith from 'lodash/cloneDeepWith';
import isEqualWith from 'lodash/isEqualWith';
import lodashGet from 'lodash/get';
import { checkMasterInfo, getAccountAuthList } from '@mail/jmail';
import cloneDeep from 'lodash/cloneDeep';
import { api } from '@/api/api';
import { ErrMsgCodeMap } from '@/api/errMap';
import { globalStoreConfig } from '@/api/data/store';
import { apis, environment, inWindow } from '@/config';
import { JsonFormatter } from '../../api_system/system_impl';
import { pathNotInArrJudge, wait } from '@/api/util';
import { locationHelper } from '@/api/util/location_helper';
import { SubAccountExpired } from '@/const';
import { inWindowTool } from '../../../utils/inWindow';
class StoreSeqHelper {
    constructor(name, key, initSeq) {
        this.name = name;
        this.key = key;
        this._seq = 0;
        this.curWinId = initSeq || 0;
        this.systemApi = api.getSystemApi();
        const inElectron = this.systemApi.isElectron() && window.electronLib;
        if (inElectron) {
            this.initCurWinId();
        }
    }
    async initCurWinId() {
        const curWin = await window.electronLib.windowManage.getCurWindow();
        this.curWinId = (curWin === null || curWin === void 0 ? void 0 : curWin.id) || 0;
    }
    next() {
        const item = this.getItem();
        if (item) {
            this._seq = parseInt(item, 10);
        }
        this._seq += 1;
        this.setItem();
        const inElectron = this.systemApi.isElectron() && window.electronLib;
        if (inElectron) {
            return this.curWinId * 10000 + this._seq;
        }
        return this._seq;
    }
    nextOne(_account) {
        var _a;
        const account = _account || ((_a = this.systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.id) || '';
        const item = this.getItem();
        if (item) {
            this._seq = parseInt(item, 10);
        }
        this._seq += 1;
        this.setItem();
        return account + '&seq&' + this._seq;
    }
    setItem() {
        localStorage.setItem(this.key, this._seq + '');
    }
    getItem() {
        return localStorage.getItem(this.key);
    }
    setSeq(seq) {
        this._seq = seq;
        this.setItem();
    }
    current() {
        const item = this.getItem();
        if (item) {
            this._seq = parseInt(item, 10);
        }
        return this._seq;
    }
}
class StoreLockHelper {
    constructor(name, storeApi, timeout, lockInOnePage) {
        this.lockKey = name;
        this.lockInOnePage = !!lockInOnePage;
        this.lockTime = -1;
        this.waitList = [];
        this.runningTask = 0;
        this.timeoutTask = 0;
        this.hasLock = false;
        this.timeout = timeout;
        this.storeApi = storeApi;
    }
    async lock(eventId) {
        const storeLock = this.storeApi.storeLock(this.lockKey, eventId);
        if (storeLock === 1) {
            return this.lockSucceed();
        }
        if (storeLock === 0) {
            await wait(100);
            if (this.storeApi.lockNotHoldByCurrentPage(this.storeApi.getLockStruct(this.lockKey))) {
                return this.lockFailed(eventId);
            }
            return this.lockSucceed();
        }
        if (storeLock === -1) {
            return this.lockFailed(eventId);
        }
        return Promise.reject(new Error('错误的返回码' + storeLock + ' 未知错误'));
    }
    destroyLock() {
        var _a;
        this.storeApi.removeLock(this.lockKey);
        this.waitList = [];
        this.hasLock = false;
        (_a = this.storeApi) === null || _a === void 0 ? void 0 : _a.removeLock(this.lockKey);
    }
    unlock() {
        if (this.runningTask > 0) {
            this.runningTask -= 1;
        }
        if (this.waitList.length === 0 && this.hasLock) {
            if (this.runningTask - this.timeoutTask <= 0) {
                this.storeApi.removeLock(this.lockKey);
                this.hasLock = false;
            }
            else {
            }
        }
        else {
            this.refreshWaitingList();
        }
    }
    lockSucceed() {
        if (!this.lockInOnePage) {
            this.refreshWaitingList();
        }
        this.runningTask += 1;
        this.hasLock = true;
        return Promise.resolve(undefined);
    }
    lockFailed(eventId) {
        const now = new Date().getTime();
        return new Promise((r, j) => {
            let eid = -1;
            const tid = setTimeout(() => {
                if (eid > 0) {
                    delete this.waitList[eid - 1];
                    this.timeoutTask += 1;
                }
                j({
                    content: 'wait lock time exceed limit ' + DataStoreImpl.MAX_LOCK_EXPIRED,
                    code: 'storedLockTimeout',
                });
            }, this.timeout || DataStoreImpl.MAX_LOCK_EXPIRED);
            eid = this.waitList.push({
                time: now,
                eventId: eventId || '',
                func: () => {
                    clearTimeout(tid);
                    this.runningTask += 1;
                    this.hasLock = true;
                    r(undefined);
                },
                abort: () => {
                    clearTimeout(tid);
                    this.runningTask -= 1;
                    j(new Error('用户取消'));
                },
            });
        });
    }
    abortWaitItem(eventId) {
        const abortIndex = this.waitList.findIndex(item => item.eventId === eventId);
        if (abortIndex > -1) {
            if (this.waitList[abortIndex]) {
                this.waitList[abortIndex].abort();
                this.waitList.splice(abortIndex, 1);
            }
        }
    }
    refreshWaitingList() {
        if (this.waitList && this.waitList.length > 0) {
            if (!this.storeApi.lockNotHoldByCurrentPage(this.storeApi.getLockStruct(this.lockKey))) {
                let item;
                do {
                    item = this.waitList.shift();
                    if (item && item.func) {
                        item.func();
                    }
                    if (this.lockInOnePage) {
                        break;
                    }
                } while (item);
                this.timeoutTask = 0;
            }
            else {
                console.warn('wtf, what happened to this lock:' + this.lockKey);
            }
        }
    }
    async notify(oldKey, newKey, ck) {
        console.log('[store] shift key storage:', this.lockKey, oldKey, newKey);
        if (newKey) {
            this.notifyMsg = JSON.parse(newKey);
        }
        else if (oldKey !== ck) {
            if (this.waitList.length - this.timeoutTask > 0) {
                const storeLock = this.storeApi.storeLock(this.lockKey);
                if (storeLock === 0) {
                    await wait(100);
                    if (this.storeApi.lockNotHoldByCurrentPage(this.storeApi.getLockStruct(this.lockKey))) {
                    }
                    else {
                        this.refreshWaitingList();
                    }
                }
                else if (storeLock === 1) {
                    this.refreshWaitingList();
                }
                else if (storeLock === -1) {
                }
            }
            else {
            }
        }
        else {
            throw new Error('what happened for lock:' + this.lockKey + ' with ' + oldKey + ' to ' + newKey);
        }
    }
}
const dataMemoryStore = new Map();
const storageTable = {
    dbName: 'storageDB',
    tableName: 'localStorage',
};
class DataStoreImpl {
    constructor() {
        this.userAccountKey = 'currentLoginUserAccount';
        this.nodeKey = 'currentNodeStore';
        this.errorKey = '-----------';
        this.watchedStoreKey = new Set();
        this.logoutStatusKey = 'user_logout_status';
        this.name = apis.defaultDataStoreApiImpl;
        this.propMap = {};
        this.subAccountPropMap = {};
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.dbApi = api.requireLogicalApi(apis.dexieDbApi);
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.clientId = ('t-' + new Date().getTime().toString(16) + '-' + config('16', 'genRandomKey'));
        this.locks = {};
        this.initUserAuthReady = new Promise(resolve => {
            this.initUserAuthResolve = resolve;
        });
    }
    getKeyPrefix(config) {
        const prefix = (config ? config.prefix || '' : '');
        if (config && config.noneUserRelated) {
            return prefix;
        }
        const emailId = this.getEmailIdByEmail((config === null || config === void 0 ? void 0 : config._account) || '');
        const currentUser = emailId ? DataStoreImpl.subAccountUserMap[emailId] : DataStoreImpl.user;
        if (!currentUser) {
            return this.errorKey;
        }
        const { accountMd5 } = currentUser;
        return accountMd5 + prefix + '-';
    }
    storeLock(key, eventId = '') {
        let strLock = this.getLockStruct(key);
        const now = new Date().getTime();
        if (strLock) {
            if (strLock.lockClientId !== this.clientId && strLock.lockTime + DataStoreImpl.MAX_LOCK_EXPIRED >= now) {
                return -1;
            }
            if (strLock.lockClientId === this.clientId && strLock.lockTime + DataStoreImpl.MAX_LOCK_EXPIRED >= now) {
                if (eventId && strLock.lockEventId !== eventId) {
                    return -1;
                }
                strLock.lockTime = now;
                localStorage.setItem(key, JSON.stringify(strLock));
                return 1;
            }
        }
        else {
        }
        strLock = {
            lockClientId: this.clientId,
            lockTime: now,
            lockEventId: eventId || '',
        };
        localStorage.setItem(key, JSON.stringify(strLock));
        return 0;
    }
    getLockStruct(key) {
        const item = localStorage.getItem(key);
        let strLock;
        if (item) {
            strLock = JSON.parse(item);
        }
        return strLock;
    }
    lockNotHoldByCurrentPage(strLock) {
        if (!strLock) {
            return false;
        }
        const now = new Date().getTime();
        return strLock.lockTime + DataStoreImpl.MAX_LOCK_EXPIRED >= now && strLock.lockClientId !== this.clientId;
    }
    removeLock(key) {
        const lockStruct = this.getLockStruct(key);
        if (lockStruct) {
            if (lockStruct.lockClientId === this.clientId || !lockStruct.lockClientId) {
                localStorage.removeItem(key);
            }
            else {
                console.warn('[store] lock not hold by current page, current lock id is ' + lockStruct.lockClientId + ' rather than ' + this.clientId);
            }
        }
    }
    getLock(name, timeout, createNone, lockInOnePage) {
        if (!name) {
            throw new Error('参数错误');
        }
        const key = this.makeKey('lock-', name);
        if (key === this.errorKey) {
            throw new Error('login status not proper');
        }
        if (key in this.locks && Object.prototype.hasOwnProperty.apply(this.locks, [key]) && this.locks[key]) {
            return this.locks[key];
        }
        if (createNone) {
            throw new Error('no lock exist');
        }
        const lockHelper = new StoreLockHelper(key, this, timeout, lockInOnePage);
        this.locks[key] = lockHelper;
        return lockHelper;
    }
    getSeqHelper(name, initSeq) {
        const key = this.makeKey('seq-', name);
        if (key === this.errorKey) {
            throw new Error('no login user');
        }
        return new StoreSeqHelper(name, key, initSeq);
    }
    getCurrentSubAccountsListKey() {
        if (DataStoreImpl.user) {
            return `${DataStoreImpl.user.id}-subAccountsList`;
        }
        return '';
    }
    addSubAccountToList(emailInfo) {
        if (!DataStoreImpl.user) {
            return;
        }
        const existList = this.getSubAccountList();
        if (existList.length) {
            const sameEmailItem = existList.find(item => item.email === emailInfo.email);
            if (!sameEmailItem) {
                existList.push(emailInfo);
            }
            else {
                sameEmailItem.agentEmail = emailInfo.agentEmail;
            }
        }
        else {
            existList.push(emailInfo);
        }
        this.saveNewSubAccountList(existList);
    }
    getSubAccountList() {
        const subAccountsListKey = this.getCurrentSubAccountsListKey();
        if (!subAccountsListKey) {
            return [];
        }
        const existListRes = this.getSync(subAccountsListKey, globalStoreConfig);
        let existList = [];
        if (existListRes.suc && existListRes.data) {
            try {
                existList = JSON.parse(existListRes.data);
            }
            catch (ex) {
                console.error(ex);
            }
        }
        return existList;
    }
    getEmailIdByEmail(email, returnExpired) {
        if (email === SubAccountExpired && returnExpired) {
            return SubAccountExpired;
        }
        if (DataStoreImpl.user) {
            if (email === DataStoreImpl.user.id || (DataStoreImpl.user.loginAccount && email === DataStoreImpl.user.loginAccount)) {
                return '';
            }
        }
        return DataStoreImpl.subAccountEmailMap[email] || (returnExpired ? SubAccountExpired : '');
    }
    getAgentEmailByEmail(email) {
        if (!email || !email.length)
            return '';
        if (DataStoreImpl.user) {
            if (email === DataStoreImpl.user.id || (DataStoreImpl.user.loginAccount && email === DataStoreImpl.user.loginAccount)) {
                return DataStoreImpl.user.id;
            }
        }
        return DataStoreImpl.subAccountAgentEmailMap[email] || '';
    }
    saveNewSubAccountList(list) {
        const subAccountsListKey = this.getCurrentSubAccountsListKey();
        if (!subAccountsListKey) {
            return;
        }
        this.initSubAccountEmailMap(list);
        this.putSync(subAccountsListKey, JSON.stringify(list), globalStoreConfig);
    }
    removeSubAccountFromList(email) {
        const emailId = this.getEmailIdByEmail(email);
        if (emailId) {
            this.setLastAccount(undefined, emailId);
        }
        if (!DataStoreImpl.user) {
            return;
        }
        const existList = this.getSubAccountList();
        if (existList && existList.length) {
            const newList = existList.filter(item => item.email !== email && item.agentEmail !== email);
            this.saveNewSubAccountList(newList);
        }
    }
    getUserProp(key, email) {
        const emailId = this.getEmailIdByEmail(email || '');
        const currentUser = emailId ? DataStoreImpl.subAccountUserMap[emailId] : DataStoreImpl.user;
        return currentUser && currentUser.prop ? currentUser.prop[key] : undefined;
    }
    setUserProp(key, value, store, emailParam) {
        var _a;
        try {
            const emailId = this.getEmailIdByEmail(emailParam || '');
            const emailUser = emailId ? DataStoreImpl.subAccountUserMap[emailId] : DataStoreImpl.user;
            if (emailUser) {
                const prop = emailUser.prop ? Object.assign({}, emailUser.prop) : {};
                const newUser = Object.assign(Object.assign({}, emailUser), { prop });
                newUser.prop[key] = value;
                if (key === DataStoreImpl.companyProp) {
                    newUser.company = value;
                }
                if (!emailId) {
                    DataStoreImpl.user = newUser;
                }
                else {
                    DataStoreImpl.subAccountUserMap[emailId] = newUser;
                }
                if (store) {
                    (_a = this.storeUser(newUser, emailParam)) === null || _a === void 0 ? void 0 : _a.then();
                }
            }
            else if (emailId) {
                if (!this.subAccountPropMap[emailId]) {
                    this.subAccountPropMap[emailId] = {};
                }
                this.subAccountPropMap[emailId][key] = value;
            }
            else {
                this.propMap[key] = value;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    getCurrentNode(email) {
        const emailId = this.getEmailIdByEmail(email || '') || email || '';
        return emailId ? DataStoreImpl.subAccountNodeMap[emailId] || 'hz' : DataStoreImpl.node;
    }
    setCurrentNode(node, email) {
        const emailId = this.getEmailIdByEmail(email || '') || email || '';
        const accountNodeKey = emailId ? this.getSubAccountCurrentNodeKey(DataStoreImpl.user.id, emailId) : this.nodeKey;
        if (node) {
            if (emailId) {
                DataStoreImpl.subAccountNodeMap[emailId] = node;
            }
            else {
                DataStoreImpl.node = node;
            }
            const res = this.putSync(accountNodeKey, node, globalStoreConfig);
            if (res) {
                console.log('[store] error store node : ' + res);
            }
            else {
                console.log('[store] node store success ');
            }
        }
        else {
            this.del(accountNodeKey, globalStoreConfig).then();
        }
    }
    async setCurrentUser(loginUser, email) {
        const emailId = this.getEmailIdByEmail(email || '');
        await this.setLastAccount(loginUser, emailId);
    }
    switchCurrentUser(email) {
        var _a;
        if (((_a = DataStoreImpl.user) === null || _a === void 0 ? void 0 : _a.id) !== email && !DataStoreImpl.subAccountUserMap[email]) {
            return false;
        }
        if (DataStoreImpl.user && DataStoreImpl.subAccountUserMap) {
            DataStoreImpl.subAccountUserMap[DataStoreImpl.user.id] = DataStoreImpl.user;
            DataStoreImpl.user = DataStoreImpl.subAccountUserMap[email];
            DataStoreImpl.subAccountUserMap[email] = undefined;
            delete DataStoreImpl.subAccountUserMap[email];
            this.put('curMainAccount', JSON.stringify(DataStoreImpl.user), { noneUserRelated: true });
            return true;
        }
        return false;
    }
    getCurrentUser(email) {
        const emailId = this.getEmailIdByEmail(email || '');
        return emailId ? DataStoreImpl.subAccountUserMap[emailId] : DataStoreImpl.user;
    }
    getUsers() {
        const mainUser = DataStoreImpl.user;
        const allUsers = DataStoreImpl.subAccountUserMap;
        if (mainUser && allUsers) {
            return {
                main: mainUser,
                all: allUsers,
            };
        }
    }
    putSync(key, data, config) {
        const prefix = this.getKeyPrefix(config);
        try {
            const key1 = this.makeKey(prefix, key);
            if (key1 === this.errorKey) {
                return 'login status not proper';
            }
            this.putDataAction(config, key1, data, key);
            return '';
        }
        catch (e) {
            console.error('[store] put error for key:' + key, e);
            throw new Error(ErrMsgCodeMap['STORAGE.SAVE.EXCEPTION'] + ' ' + key);
        }
    }
    putDataAction(config, key1, data, key) {
        if (!config || !config.storeMethod || config.storeMethod === 'localStorage') {
            localStorage.setItem(key1, data);
            console.log('[store] store put ' + key + '-->', data);
        }
        else if (config.storeMethod === 'memory') {
            dataMemoryStore.set(key1, data);
        }
    }
    putToDBDataAction(key, data) {
        try {
            return this.dbApi.put(storageTable, {
                key,
                value: data,
            });
        }
        catch (ex) {
            throw ex;
        }
    }
    getSync(key, conf) {
        const prefix = this.getKeyPrefix(conf);
        const key1 = this.makeKey(prefix, key);
        if (key1 === this.errorKey) {
            return {
                key: key1,
                suc: false,
                err: 'login status not proper',
            };
        }
        const content = this.getDataAction(conf, key1);
        if (content) {
            const data = content;
            return this.buildContent(key, key1, data);
        }
        return {
            key: key1,
            suc: false,
            err: 'not found key',
        };
    }
    getKey(key, conf) {
        return this.makeKey(this.getKeyPrefix(conf), key);
    }
    getDataAction(conf, key1) {
        if (!inWindow()) {
            return null;
        }
        let content;
        if (!conf || !conf.storeMethod || conf.storeMethod === 'localStorage') {
            content = localStorage.getItem(key1);
        }
        else if (conf.storeMethod === 'memory') {
            content = dataMemoryStore.get(key1);
        }
        return content;
    }
    async getDataFromDB(key) {
        const dbInfo = await this.dbApi.getById(storageTable, key);
        return dbInfo ? dbInfo.value : undefined;
    }
    getFromDB(key, conf) {
        const prefix = this.getKeyPrefix(conf);
        return new Promise(async (r, j) => {
            try {
                const key1 = this.makeKey(prefix, key);
                if (key1 === this.errorKey) {
                    r({
                        key: key1,
                        suc: false,
                        err: 'login status not proper',
                    });
                }
                const content = await this.getDataFromDB(key1);
                if (content) {
                    const data = content;
                    r(this.buildContent(key, key1, data));
                }
                else {
                    r({
                        key: key1,
                        suc: false,
                        err: 'not found key',
                    });
                }
            }
            catch (e) {
                j(new Error(ErrMsgCodeMap['STORAGE.READ.EXCEPTION'] + ' ' + key));
            }
        });
    }
    get(key, conf) {
        const prefix = this.getKeyPrefix(conf);
        return new Promise((r, j) => {
            try {
                const key1 = this.makeKey(prefix, key);
                if (key1 === this.errorKey) {
                    r({
                        key: key1,
                        suc: false,
                        err: 'login status not proper',
                    });
                }
                const content = this.getDataAction(conf, key1);
                if (content) {
                    const data = content;
                    r(this.buildContent(key, key1, data));
                }
                else {
                    r({
                        key: key1,
                        suc: false,
                        err: 'not found key',
                    });
                }
            }
            catch (e) {
                j(new Error(ErrMsgCodeMap['STORAGE.READ.EXCEPTION'] + ' ' + key));
            }
        });
    }
    buildContent(key, key1, data) {
        return {
            originKey: key,
            key: key1,
            data,
            suc: true,
        };
    }
    makeKey(prefix, key) {
        if (prefix === this.errorKey) {
            console.warn('[store] login status not proper for such action');
            return prefix;
        }
        if (environment === 'local' || environment === 'test' || environment === 'dev') {
            return prefix + key;
        }
        return prefix + MD5(key + DataStoreImpl.salt).toString(enc.Base64);
    }
    putToDB(key, data, conf) {
        const prefix = this.getKeyPrefix(conf);
        return new Promise(async (r, j) => {
            try {
                const key1 = this.makeKey(prefix, key);
                if (key1 === this.errorKey) {
                    j(new Error('login status not proper'));
                }
                await this.putToDBDataAction(key1, data);
                r('');
            }
            catch (e) {
                console.error('[store] putToDB error for key:' + key, e);
                j(new Error(ErrMsgCodeMap['STORAGE.SAVE.EXCEPTION'] + ' ' + key));
            }
        });
    }
    put(key, data, conf) {
        const prefix = this.getKeyPrefix(conf);
        return new Promise((r, j) => {
            try {
                const key1 = this.makeKey(prefix, key);
                if (key1 === this.errorKey) {
                    j(new Error('login status not proper'));
                }
                this.putDataAction(conf, key1, data, key);
                r('');
            }
            catch (e) {
                console.error('[store] put error for key:' + key, e);
                j(new Error(ErrMsgCodeMap['STORAGE.SAVE.EXCEPTION'] + ' ' + key));
            }
        });
    }
    clear(conf) {
        return new Promise((r, j) => {
            try {
                const isLocalStorage = !conf || !conf.storeMethod || conf.storeMethod === 'localStorage';
                const isMemory = (conf === null || conf === void 0 ? void 0 : conf.storeMethod) === 'memory';
                if (conf && conf.noneUserRelated) {
                    if (isLocalStorage) {
                        localStorage.clear();
                    }
                    else if (isMemory) {
                        dataMemoryStore.clear();
                    }
                }
                else {
                    let keys;
                    if (isLocalStorage) {
                        keys = Object.keys(localStorage);
                    }
                    else if (isMemory) {
                        keys = Object.keys(dataMemoryStore);
                    }
                    if (keys) {
                        const emailId = this.getEmailIdByEmail((conf === null || conf === void 0 ? void 0 : conf._account) || '');
                        const currentUser = emailId ? DataStoreImpl.subAccountUserMap[emailId] : DataStoreImpl.user;
                        keys.forEach(localStorageKey => {
                            if (currentUser) {
                                const lastAccountMd5 = currentUser.accountMd5;
                                if (Object.prototype.hasOwnProperty.apply(localStorage, [localStorageKey]) && localStorageKey.startsWith(lastAccountMd5)) {
                                    if (isLocalStorage) {
                                        localStorage.removeItem(localStorageKey);
                                    }
                                    else if (isMemory) {
                                        dataMemoryStore.delete(localStorageKey);
                                    }
                                }
                            }
                        });
                    }
                }
                r('');
            }
            catch (e) {
                j(e);
            }
        });
    }
    delFromDB(key, conf) {
        const prefix = this.getKeyPrefix(conf);
        return new Promise(async (r, j) => {
            try {
                const key1 = this.makeKey(prefix, key);
                if (key1 === this.errorKey) {
                    r('login status not proper');
                }
                await this.dbApi.deleteById(storageTable, key1);
                r('');
            }
            catch (e) {
                j(new Error(ErrMsgCodeMap['STORAGE.SAVE.EXCEPTION'] + ' ' + key));
            }
        });
    }
    del(key, conf) {
        const prefix = this.getKeyPrefix(conf);
        return new Promise((r, j) => {
            try {
                const key1 = this.makeKey(prefix, key);
                if (key1 === this.errorKey) {
                    r('login status not proper');
                }
                const isLocalStorage = !conf || !conf.storeMethod || conf.storeMethod === 'localStorage';
                const isMemory = (conf === null || conf === void 0 ? void 0 : conf.storeMethod) === 'memory';
                if (isLocalStorage) {
                    localStorage.removeItem(key1);
                }
                else if (isMemory) {
                    dataMemoryStore.delete(key1);
                }
                console.log('[store] store del', key);
                r('');
            }
            catch (e) {
                j(new Error(ErrMsgCodeMap['STORAGE.SAVE.EXCEPTION'] + ' ' + key));
            }
        });
    }
    async setLastAccount(lst, emailParam) {
        const emailId = emailParam;
        if (!emailId) {
            DataStoreImpl.user = lst;
        }
        else {
            DataStoreImpl.subAccountUserMap[emailParam] = lst;
        }
        const propMap = emailParam ? this.subAccountPropMap[emailParam] || {} : this.propMap;
        Object.keys(propMap).forEach(propMapKey => {
            if (Object.prototype.hasOwnProperty.apply(propMap, [propMapKey]) && propMap[propMapKey]) {
                this.setUserProp(propMapKey, propMap[propMapKey], false, emailParam);
                delete propMap[propMapKey];
            }
        });
        try {
            if (!emailParam) {
                this.watchContact();
            }
            else {
                this.watchContact(undefined, emailParam);
            }
        }
        catch (ex) {
            console.error('watchContact-error', ex);
        }
        try {
            await this.storeUser(lst, emailParam);
            return 'success';
        }
        catch (e) {
            return 'fail';
        }
    }
    addWatchedKey(key, config) {
        const keyPrefix = this.getKeyPrefix(config);
        const s = this.makeKey(keyPrefix, key);
        this.watchedStoreKey.add(s);
    }
    decryptMsg(content, key) {
        try {
            const array = AES.decrypt(content, key, {
                format: JsonFormatter,
            });
            return array.toString(enc.Utf8);
        }
        catch (ex) {
            return content;
        }
    }
    md5(content) {
        return MD5(content).toString(enc.Base64);
    }
    isLogout(email) {
        const emailId = this.getEmailIdByEmail(email || '');
        const logoutStatusKey = emailId ? this.getSubAccountLogoutStatusKey(DataStoreImpl.user.id, emailId) : this.logoutStatusKey;
        const sync = this.getSync(logoutStatusKey, { storeMethod: 'memory' });
        return !!sync && sync.suc && !!sync.data && sync.data === 'true';
    }
    getUUID() {
        return DataStoreImpl.uuid;
    }
    loadUUID() {
        const uuidStore = this.getSync(DataStoreImpl.keyDeviceUUID, globalStoreConfig);
        let uuid = '';
        if (uuidStore && uuidStore.suc && uuidStore.data && uuidStore.data !== 'undefined') {
            console.log('[store] client uuid !!!!!------- ' + uuidStore.data);
            uuid = uuidStore.data;
        }
        else {
            uuid = ('i-' + new Date().getTime().toString(16) + '-' + config('16', 'genRandomKey'));
            this.put(DataStoreImpl.keyDeviceUUID, uuid, globalStoreConfig).then(() => {
                console.log('[store] client uuid !!!!------- ' + uuid);
            });
        }
        DataStoreImpl.uuid = uuid;
        return uuid;
    }
    getShouldInitLoadUser() {
        if (process.env.BUILD_ISWEB) {
            try {
                const isWebmail = config && config('profile') && config('profile').startsWith('webmail');
                if (isWebmail) {
                    if (inWindowTool()) {
                        const currentPathName = window.location.pathname;
                        if (currentPathName.includes('/jump/')) {
                            return false;
                        }
                    }
                }
                return true;
            }
            catch (ex) {
                console.error('loadUser error:', ex);
                return true;
            }
        }
        return true;
    }
    loadUser() {
        const noDecrypt = !!(inWindow() && !window.featureSupportInfo.supportCrypto);
        const pass = noDecrypt ? { suc: true, data: 'ok' } : this.getSync(DataStoreImpl.defaultPassKey, globalStoreConfig);
        const res = this.getSync(this.userAccountKey, globalStoreConfig);
        if (pass.suc && pass.data && res.suc && res.data) {
            console.warn('[store] load user !!!!!!---------', res.data);
            const realData = noDecrypt ? res.data : this.decryptMsg(res.data, pass.data);
            DataStoreImpl.user = JSON.parse(realData);
        }
        else {
            console.warn('[store] no load user !!!!!!---------', res);
        }
    }
    loadSubAccountsUser() {
        if (!DataStoreImpl.user) {
            return;
        }
        const subAccountList = this.getSubAccountList();
        this.initSubAccountEmailMap(subAccountList);
        if (subAccountList && subAccountList.length) {
            const noDecrypt = !!(inWindow() && !window.featureSupportInfo.supportCrypto);
            const pass = noDecrypt ? { suc: true, data: 'ok' } : this.getSync(DataStoreImpl.defaultPassKey, globalStoreConfig);
            subAccountList.forEach(item => {
                const subAccountKey = this.getSubAccountCurrentUserKey(DataStoreImpl.user.id, item.email);
                const subAccounRes = this.getSync(subAccountKey, globalStoreConfig);
                if (pass.suc && pass.data && subAccounRes.suc && subAccounRes.data) {
                    const realData = noDecrypt ? subAccounRes.data : this.decryptMsg(subAccounRes.data, pass.data);
                    DataStoreImpl.subAccountUserMap[item.email] = JSON.parse(realData);
                }
            });
        }
    }
    loadNode() {
        const result = this.getSync(this.nodeKey, globalStoreConfig);
        if (result.suc && result.data) {
            console.log('[store] load node !!!!!!!---------', result.data);
            DataStoreImpl.node = result.data;
        }
    }
    loadSubAccountsNode() {
        if (!DataStoreImpl.user) {
            return;
        }
        const subAccountList = this.getSubAccountList();
        this.initSubAccountEmailMap(subAccountList);
        if (subAccountList && subAccountList.length) {
            subAccountList.forEach(item => {
                const subAccountKey = this.getSubAccountCurrentNodeKey(DataStoreImpl.user.id, item.email);
                const subAccounRes = this.getSync(subAccountKey, globalStoreConfig);
                if (subAccounRes.suc && subAccounRes.data) {
                    DataStoreImpl.subAccountNodeMap[item.email] = subAccounRes.data;
                }
            });
        }
    }
    initSubAccountEmailMap(subAccountListParam) {
        const subAccountList = subAccountListParam || this.getSubAccountList();
        if (subAccountList && subAccountList.length) {
            DataStoreImpl.subAccountEmailMap = {};
            subAccountList.forEach(item => {
                DataStoreImpl.subAccountEmailMap[item.email] = item.email;
                DataStoreImpl.subAccountEmailMap[item.agentEmail] = item.email;
                DataStoreImpl.subAccountAgentEmailMap[item.email] = item.agentEmail;
                DataStoreImpl.subAccountAgentEmailMap[item.agentEmail] = item.agentEmail;
            });
        }
    }
    getSubAccountCurrentUserKey(mainEmail, accountEmail) {
        return `${mainEmail || ''}-${accountEmail || ''}-${this.userAccountKey}`;
    }
    getSubAccountCurrentNodeKey(mainEmail, accountEmail) {
        return `${mainEmail || ''}-${accountEmail || ''}-${this.nodeKey}`;
    }
    getSubAccountLogoutStatusKey(mainEmail, accountEmail) {
        return `${mainEmail || ''}-${accountEmail || ''}-${this.logoutStatusKey}`;
    }
    async putSubAccountState(val) {
        const { email, agentEmail, node, loginUser } = val;
        this.loggerApi.track('syncSubAccountState_putSubAccountState', { val });
        if (!loginUser) {
            return;
        }
        this.addSubAccountToList({ email, agentEmail });
        this.setCurrentNode(node, email);
        await this.setCurrentUser(loginUser, email);
    }
    getSubAccountState() {
        const agentAccount = this.systemApi.getCurrentAgentAccount();
        if (DataStoreImpl.user) {
            return {
                email: DataStoreImpl.user.id,
                agentEmail: agentAccount.email,
                node: DataStoreImpl.node,
                loginUser: DataStoreImpl.user,
            };
        }
        return undefined;
    }
    async storeUser(data, emailParam) {
        var _a;
        const isEnable = inWindow() &&
            (process.env.BUILD_ISWEB || !pathNotInArrJudge(window.location, ['/', '/index.html', '/login', '/mlogin', '/jump', '/account-bg', '/api_data_init.html']));
        if (!isEnable) {
            return;
        }
        const userAccountKey = !emailParam ? this.userAccountKey : this.getSubAccountCurrentUserKey(((_a = DataStoreImpl.user) === null || _a === void 0 ? void 0 : _a.id) || '', emailParam);
        if (data) {
            const data1 = window.featureSupportInfo.supportCrypto ? await this.systemApi.encryptMsg(JSON.stringify(data)) : JSON.stringify(data);
            let hasAlreadyPutted = false;
            try {
                const passAndUser = await Promise.all([this.get(DataStoreImpl.defaultPassKey, globalStoreConfig), this.get(userAccountKey, globalStoreConfig)]);
                const [pass, userEncryptionInfo] = passAndUser;
                if (pass && pass.suc && userEncryptionInfo && userEncryptionInfo.suc) {
                    const realUserStr = this.decryptMsg(userEncryptionInfo.data, pass.data);
                    const userInfo = JSON.parse(realUserStr);
                    hasAlreadyPutted = isEqualWith(userInfo, data, (objCookieArr, newCookieArr, field) => {
                        if (field && field === 'cookie') {
                            return this.systemApi.md5(objCookieArr) === this.systemApi.md5(newCookieArr);
                        }
                        if (field && field === 'avatar') {
                            return objCookieArr === newCookieArr;
                        }
                    });
                    console.log('[store] compared', hasAlreadyPutted, userInfo, data);
                }
            }
            catch (ex) {
                console.warn('[store] load old user failed:' + ex);
            }
            if (!hasAlreadyPutted) {
                await this.put(userAccountKey, data1, globalStoreConfig).then(res => {
                    if (res) {
                        console.log('[store] error store user: ' + res);
                    }
                    else {
                        console.log('[store] user store success');
                    }
                });
            }
            else {
                console.log('[store] userstore has  written');
            }
            this.eventApi.sendSysEvent({
                eventName: 'storeUserChangeEvent',
                eventStrData: 'storeUser',
                eventData: {
                    data: cloneDeepWith(data, (...args) => {
                        if (Array.isArray(args) && args.length > 1 && args[0] === 'cookie') {
                            return this.systemApi.md5(args[0]);
                        }
                    }),
                    needWrite: !hasAlreadyPutted,
                },
                _account: emailParam,
            });
        }
        else {
            await this.del(userAccountKey, globalStoreConfig);
        }
    }
    watchContact(ev, emailParam) {
        const currentUser = this.getCurrentUser(emailParam);
        if (currentUser && this.contactApi.isInited()) {
            if (currentUser && ev && ev._account !== currentUser.id) {
                return undefined;
            }
            const accountParam = emailParam ? currentUser.id : undefined;
            console.log('[im.myaccount]storeContactInit:', currentUser);
            const userPromise = this.contactApi.doGetContactByItem({
                type: 'EMAIL',
                value: [currentUser.id],
                _account: accountParam,
            });
            const orgPromise = this.contactApi.doGetOrgList({ typeList: [99], _account: accountParam });
            return Promise.all([userPromise, orgPromise]).then(res => {
                var _a;
                const [value, org] = res;
                let change = false;
                if (value && value.length > 0) {
                    const model = value.filter(it => it && it.contact && it.contact.type === 'enterprise').pop();
                    if (model && model.contact) {
                        if (model.contact.position && model.contact.position.length > 0) {
                            const it = model.contact.position[0].join('-');
                            if (this.getUserProp('department', emailParam) !== it) {
                                this.setUserProp('department', it, false, emailParam);
                                change = true;
                            }
                        }
                        if (lodashGet(model, 'contactInfo.length', 0) > lodashGet(currentUser, 'contact.contactInfo.length', 0)) {
                            change = true;
                        }
                        const user = !emailParam ? DataStoreImpl.user : DataStoreImpl.subAccountUserMap[emailParam];
                        if (user) {
                            const newUser = Object.assign({}, user);
                            if (model && model.contact) {
                                if (newUser.avatar !== model.contact.avatar) {
                                    newUser.avatar = model.contact.avatar || '';
                                    change = true;
                                }
                            }
                            if (model && model.contact && model.contact.contactName) {
                                if (newUser.nickName !== model.contact.contactName) {
                                    newUser.nickName = model.contact.contactName;
                                    change = true;
                                }
                            }
                            newUser.contact = model;
                            if (!emailParam) {
                                DataStoreImpl.user = newUser;
                            }
                            else {
                                DataStoreImpl.subAccountUserMap[emailParam] = newUser;
                            }
                        }
                    }
                }
                if (org && org.length > 0) {
                    const corp = org[0];
                    const user = !emailParam ? DataStoreImpl.user : DataStoreImpl.subAccountUserMap[emailParam];
                    if (user) {
                        if (this.getUserProp('company', emailParam) !== corp.orgName) {
                            this.setUserProp('company', corp.orgName, false, emailParam);
                            change = true;
                        }
                        if (this.getUserProp('companyId', emailParam) !== corp.originId) {
                            this.setUserProp('companyId', corp.originId, false, emailParam);
                            change = true;
                        }
                    }
                }
                if (change) {
                    console.log('[im.myaccount]sendSysEvent:', currentUser);
                    this.eventApi.sendSysEvent({
                        eventName: 'updateUserInfo',
                        eventStrData: '',
                        eventSeq: 0,
                        eventData: currentUser,
                        eventLevel: 'info',
                        _account: accountParam,
                    });
                    const user = !emailParam ? DataStoreImpl.user : DataStoreImpl.subAccountUserMap[emailParam];
                    if (user) {
                        (_a = this.storeUser(user, emailParam)) === null || _a === void 0 ? void 0 : _a.then();
                    }
                }
            });
        }
        return undefined;
    }
    async reqAccountAuthList() {
        try {
            if (typeof window !== undefined) {
                const ckRes = checkMasterInfo();
                if (ckRes === null || ckRes === void 0 ? void 0 : ckRes.isMaster) {
                    const res = await getAccountAuthList();
                    return Object.assign(Object.assign({}, res), { suc: true });
                }
                return { suc: false };
            }
            return { suc: false };
        }
        catch (error) {
            console.error('[store] getAccountAuthList error:', error);
            return { suc: false };
        }
    }
    bindToWindow() {
        window.initUserAuth = () => {
            try {
                window.apiResposity.dataStoreApi.initUserAuth();
            }
            catch (error) {
                console.error('[store] initUserAuth error:', error);
            }
        };
    }
    async initUserAuth() {
        try {
            if (window.location.hash.substring(1) === 'nativeresetpwd') {
                return false;
            }
        }
        catch (e) {
            console.error('[store] initUserAuth error:', e);
        }
        const res = await this.reqAccountAuthList();
        const { suc: reqAccountAuthListSuc, list } = res;
        if (reqAccountAuthListSuc && list && (list === null || list === void 0 ? void 0 : list.length) > 0) {
            const authList = list;
            console.error('[store] initUserAuth:', authList);
            const users = [];
            authList.forEach((auth) => {
                if (auth.uid && auth.qiyeAuth && auth.qiyeAuth.qiyeToken) {
                    const { accountId, uid, name, qiyeAuth, qiyeAccountInfo } = auth;
                    const user = {
                        accountId: accountId || (qiyeAccountInfo === null || qiyeAccountInfo === void 0 ? void 0 : qiyeAccountInfo.accountId),
                        id: uid,
                        email: uid,
                        nickName: name || '',
                        qiyeToken: qiyeAuth === null || qiyeAuth === void 0 ? void 0 : qiyeAuth.qiyeToken,
                        accountMd5: this.md5(uid),
                        sessionId: qiyeAuth === null || qiyeAuth === void 0 ? void 0 : qiyeAuth.sid,
                        domain: (uid === null || uid === void 0 ? void 0 : uid.split('@')[1]) || '',
                        coremail: qiyeAuth === null || qiyeAuth === void 0 ? void 0 : qiyeAuth.coremailCookie.replace('Coremail:', ''),
                        node: (qiyeAccountInfo === null || qiyeAccountInfo === void 0 ? void 0 : qiyeAccountInfo.node) || 'hz',
                        version: (qiyeAccountInfo === null || qiyeAccountInfo === void 0 ? void 0 : qiyeAccountInfo.qiYeVersion) || 'free',
                        domainList: (qiyeAccountInfo === null || qiyeAccountInfo === void 0 ? void 0 : qiyeAccountInfo.domainList) || [],
                        stateTrackOn: (qiyeAccountInfo === null || qiyeAccountInfo === void 0 ? void 0 : qiyeAccountInfo.stateTrackOn) || false,
                    };
                    users.push(user);
                }
            });
            if (users === null || users === void 0 ? void 0 : users.length) {
                DataStoreImpl.subAccountUserMap = {};
                let storageCurMainAccountId = null;
                try {
                    const curMainAccountData = this.getSync('curMainAccount', { noneUserRelated: true });
                    const { suc: syncSuc, data } = curMainAccountData;
                    if (syncSuc && data) {
                        const storageCurMainAccount = JSON.parse(data);
                        storageCurMainAccountId = storageCurMainAccount === null || storageCurMainAccount === void 0 ? void 0 : storageCurMainAccount.id;
                    }
                }
                catch (error) {
                    console.error('[store] getSync curMainAccount error:', error);
                }
                const urlUid = locationHelper.getParam('uid') || locationHelper.getParam('account');
                if (urlUid) {
                    const urlUser = users.find((user) => user.id === urlUid || user.nickName === urlUid);
                    if (urlUser) {
                        storageCurMainAccountId = urlUser.id;
                        this.put('curMainAccount', JSON.stringify(urlUser), { noneUserRelated: true });
                    }
                }
                const addNickNameToSubAccount = (user) => {
                    if (user.nickName && user.id !== user.nickName) {
                        reqs.push(this.setLastAccount(cloneDeep(user), user.nickName));
                    }
                };
                const reqs = [];
                if (!storageCurMainAccountId) {
                    users.forEach((user, index) => {
                        if (index === 0) {
                            reqs.push(this.setLastAccount(cloneDeep(user)));
                            this.put('curMainAccount', JSON.stringify(user), { noneUserRelated: true });
                            addNickNameToSubAccount(user);
                        }
                        else {
                            reqs.push(this.setLastAccount(cloneDeep(user), user.id));
                            addNickNameToSubAccount(user);
                        }
                    });
                }
                else {
                    let finded = false;
                    users.forEach((user) => {
                        if (user.id === storageCurMainAccountId) {
                            finded = true;
                            reqs.push(this.setLastAccount(cloneDeep(user)));
                            addNickNameToSubAccount(user);
                        }
                        else {
                            reqs.push(this.setLastAccount(cloneDeep(user), user.id));
                            addNickNameToSubAccount(user);
                        }
                    });
                    if (!finded) {
                        this.put('curMainAccount', JSON.stringify(users[0]), { noneUserRelated: true });
                    }
                }
                console.error('data_store_impl/initUserAuth', {
                    currentUser: DataStoreImpl.user,
                    subUser: DataStoreImpl.subAccountUserMap,
                });
            }
        }
        this.initUserAuthResolve();
    }
    init() {
        const shouldLoadUser = this.getShouldInitLoadUser();
        if (shouldLoadUser) {
            this.loadUser();
        }
        this.initUserAuth();
        this.bindToWindow();
        this.loadSubAccountsUser();
        this.loadNode();
        this.loadSubAccountsNode();
        this.loadUUID();
        const globalStorageEventListener = (ev) => {
            const evKey = ev.key || '';
            if (evKey || evKey.indexOf('_hubble') >= 0) {
                return;
            }
            if (ev.key && ev.key in this.locks && this.locks[ev.key]) {
                const lock = this.locks[ev.key];
                lock.notify(ev.oldValue, ev.newValue, this.clientId).then();
            }
            else if (ev.key) {
                const prefix = this.getKeyPrefix(globalStoreConfig);
                const key1 = this.makeKey(prefix, this.userAccountKey);
                if (ev.key === key1) {
                    this.loadUser();
                }
                else if (this.watchedStoreKey.has(ev.key)) {
                    this.eventApi.sendSysEvent({
                        eventName: 'storeChangeEvent',
                        eventStrData: ev.key,
                        eventData: ev,
                    });
                }
            }
        };
        window.addEventListener('storage', debounce(globalStorageEventListener, 500, { maxWait: 1000, leading: true, trailing: false }));
        this.eventApi.registerSysEventObserver('contactNotify', {
            name: 'sysContactSyncOb',
            func: ev => {
                const eventAccount = this.getEmailIdByEmail(ev._account || '');
                this.watchContact.bind(this)(ev, eventAccount);
            },
        });
        this.eventApi.registerSysEventObserver('loginBlock', {
            name: 'systemApiLogoutOb',
            func: (ev) => {
                const emailId = this.getEmailIdByEmail((ev === null || ev === void 0 ? void 0 : ev._account) || '');
                const logoutStatusKey = emailId ? this.getSubAccountLogoutStatusKey(DataStoreImpl.user.id, emailId) : this.logoutStatusKey;
                if (ev && ev.eventData) {
                    this.putSync(logoutStatusKey, 'true', { storeMethod: 'memory' });
                }
                else {
                    this.putSync(logoutStatusKey, 'false', { storeMethod: 'memory' });
                }
            },
        });
        const subAccountUpdateEvents = ['SubAccountAdded', 'SubAccountDeleted', 'subAccountDBChanged', 'SubAccountLoginExpired'];
        subAccountUpdateEvents.forEach(eventName => {
            this.eventApi.registerSysEventObserver(eventName, {
                name: 'dataStoreApiImpl-' + eventName,
                func: () => {
                    const isMainPage = this.systemApi.isMainPage();
                    if (isMainPage)
                        return;
                    this.loadSubAccountsNode();
                    this.loadSubAccountsUser();
                },
            });
        });
        return this.name;
    }
    afterInit() {
        this.loggerApi.track('app_init_data_in_store', {
            uuid: this.getUUID(),
            node: this.getCurrentNode(),
            subAccountNodeMap: DataStoreImpl.subAccountNodeMap,
            user: this.getCurrentUser(),
            subAccountUserMap: DataStoreImpl.subAccountEmailMap,
            client: this.clientId,
        });
        return this.name;
    }
}
DataStoreImpl.MAX_LOCK_EXPIRED = 45 * 1000;
DataStoreImpl.salt = config('globalSalt');
DataStoreImpl.keyDeviceUUID = config('browerDeviceUUID');
DataStoreImpl.defaultPassKey = config('globalKey');
DataStoreImpl.user = undefined;
DataStoreImpl.subAccountUserMap = {};
DataStoreImpl.subAccountEmailMap = {};
DataStoreImpl.subAccountAgentEmailMap = {};
DataStoreImpl.companyProp = 'company';
DataStoreImpl.node = 'hz';
DataStoreImpl.subAccountNodeMap = {};
DataStoreImpl.uuid = '';
const dataStore = new DataStoreImpl();
api.registerDataStoreApi(dataStore);
export default dataStore;
